import {FC, memo, useEffect, useState} from 'react';
import {hasValue, IAttachmentData} from '@kcast-fe/core';
import {Box, Flex} from '@chakra-ui/react';
import {VideoPlayer} from 'ui-kit';
import {getOrFetchFile} from 'core';

interface IProps {
  attachment: IAttachmentData;
}

const RenderVideoFC: FC<IProps> = ({attachment}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [blob, setBlob] = useState<Blob | null>(null);
  const [videoUrl, setVideoUrl] = useState('');

  useEffect(() => {
    if (!hasValue(attachment.id)) {
      setIsLoading(false);
      return;
    }

    let isActive = true;
    getOrFetchFile(attachment)
      .then((resp) => {
        if (isActive) {
          setBlob(resp);
        }
      })
      .catch(() => console.error('[File] Download video error.'))
      .finally(() => {
        if (isActive) {
          setIsLoading(false);
        }
      });

    return () => {
      isActive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attachment.id]);

  useEffect(() => {
    if (!blob) {
      return;
    }
    const url = URL.createObjectURL(blob);
    setVideoUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [blob]);

  return (
    <Flex gap={'10px'} flexDirection={'column'}>
      <Box overflow={'hidden'} borderRadius={'12px'}>
        <VideoPlayer isLoading={isLoading} src={videoUrl} />
      </Box>
    </Flex>
  );
};

export const RenderVideo = memo(RenderVideoFC);
